var React = require('react');

function LargeClose (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#5B6770","d":"M20 5.533 18.466 4 12 10.466 5.533 4 4 5.533 10.466 12 4 18.466 5.533 20 12 13.534 18.466 20 20 18.466 13.534 12 20 5.533Z"}));
}

LargeClose.defaultProps = {"viewBox":"0 0 24 24","fill":"none"};

module.exports = LargeClose;

LargeClose.default = LargeClose;
